import { FI as payoutTableFinland } from './payoutAndPremium.ts';
import { formatCurrency } from '../../utils/formatCurrency.ts';
import { loan_application } from '@axo/shared/data-access/types';

export function InsuranceLevel({
  amount,
  currency,
}: {
  amount: number | undefined;
  currency: loan_application.Currency | null | undefined;
}) {
  if (!amount) return null;
  const match = payoutTableFinland.find((x) => x.payout === amount);
  if (!match) return null;
  if (!currency) return null;
  return `Payout: ${formatCurrency(
    amount,
    currency
  )} (premium: ${formatCurrency(match.premium, currency)})`;
}
